module.exports = __webpack_public_path__ + "static/media/detect-similar.a505783e.png";